module.exports = __webpack_public_path__ + "img/csr_swiper_01_04.f2d43a7d.jpg";